module.exports = __webpack_public_path__ + "img/pad-started-wet-session-1.78be48dc.png";